function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { VamAddonLoader } from '../../addons/loader/vam-addon-loader';
import { loadReportingAddons } from '../../addons/loader/reporting/reporting-addon-loader';
import { loadSyntheticEventAddons } from '../../addons/loader/synthetic-events-loader';
import { PlaybackType } from '../../core/player/playout-data';
import { PlayerType } from '../../core/player/player-type';
import { getSlePrerollSupport } from '../../utils/device-playback-capabilities/playback-capabilities';
import OneAppAdPolicy from './oneapp-ad-policy';
import { oneAppDrmConfig } from './proposition-player-config/drm/drm-config';
import { oneAppShakaConfig } from './proposition-player-config/shaka/shaka-config';
import { oneAppAdInsertionFactory } from './ad-insertion/oneapp-factories';
import { loadVpiProvider } from '../video-platform-integration/video-platform-integration-provider-factory';
import { loadStreamMetadataParserAddon } from '../../addons/loader/stream-metadata-parser-addon-loader';
import { PineAddonLoader } from '../../addons/loader/pine-addon-loader';
var oneAppReportingAdapters = {
    adobe: /*#__PURE__*/ _async_to_generator(function() {
        var OneAppAdobeMetaAdapter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-adb-oneapp-ma" */ './reporting/oneapp-adobe-meta-adapter')
                    ];
                case 1:
                    OneAppAdobeMetaAdapter = _state.sent().OneAppAdobeMetaAdapter;
                    return [
                        2,
                        new OneAppAdobeMetaAdapter()
                    ];
            }
        });
    }),
    comscore: /*#__PURE__*/ _async_to_generator(function() {
        var OneAppComscoreMetaAdapter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-cmscr-oneapp-ma" */ './reporting/oneapp-comscore-meta-adapter')
                    ];
                case 1:
                    OneAppComscoreMetaAdapter = _state.sent().OneAppComscoreMetaAdapter;
                    return [
                        2,
                        new OneAppComscoreMetaAdapter()
                    ];
            }
        });
    }),
    conviva: /*#__PURE__*/ _async_to_generator(function() {
        var OneAppConvivaMetaAdapter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-cv-oneapp-ma" */ './reporting/oneapp-conviva-meta-adapter')
                    ];
                case 1:
                    OneAppConvivaMetaAdapter = _state.sent().OneAppConvivaMetaAdapter;
                    return [
                        2,
                        new OneAppConvivaMetaAdapter()
                    ];
            }
        });
    }),
    nielsen: /*#__PURE__*/ _async_to_generator(function() {
        var OneAppNielsenMetaAdapter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-nlsn-oneapp-ma" */ './reporting/oneapp-nielsen-meta-adapter')
                    ];
                case 1:
                    OneAppNielsenMetaAdapter = _state.sent().OneAppNielsenMetaAdapter;
                    return [
                        2,
                        new OneAppNielsenMetaAdapter()
                    ];
            }
        });
    }),
    nielsenSdk: /*#__PURE__*/ _async_to_generator(function() {
        var OneAppNielsenSdkMetaAdapter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-nlsnsdk-oneapp-ma" */ './reporting/oneapp-nielsen-sdk-meta-adapter')
                    ];
                case 1:
                    OneAppNielsenSdkMetaAdapter = _state.sent().OneAppNielsenSdkMetaAdapter;
                    return [
                        2,
                        new OneAppNielsenSdkMetaAdapter()
                    ];
            }
        });
    })
};
var willUseNielsenSdkInstance = [
    DeviceType.Browser
];
function oneAppAddonFactories(internalConfigPerPlaybackType, device) {
    return _oneAppAddonFactories.apply(this, arguments);
}
function _oneAppAddonFactories() {
    _oneAppAddonFactories = _async_to_generator(function(internalConfigPerPlaybackType, device) {
        var addonsConfig, _ref, reportingAddonLoaders, reportingAddonFactories, vamAddonLoader, pineAddonLoader, addonLoaders, loaders, _ref1, streamMetadataParser, adInsertion, syntheticEvents, addonFactories;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    addonsConfig = internalConfigPerPlaybackType.default.addons;
                    return [
                        4,
                        loadReportingAddons(internalConfigPerPlaybackType, oneAppReportingAdapters, device, {
                            isNielsenDtvrRequired: willUseNielsenSdkInstance.includes(device.type)
                        })
                    ];
                case 1:
                    _ref = _state.sent(), reportingAddonLoaders = _ref.addonLoaders, reportingAddonFactories = _ref.addonFactories;
                    vamAddonLoader = new VamAddonLoader(device);
                    pineAddonLoader = new PineAddonLoader(device);
                    addonLoaders = _to_consumable_array(reportingAddonLoaders).concat([
                        vamAddonLoader,
                        pineAddonLoader
                    ]);
                    loaders = addonLoaders.map(function(loader) {
                        return loader.load(internalConfigPerPlaybackType);
                    });
                    return [
                        4,
                        Promise.all([
                            loadStreamMetadataParserAddon(),
                            oneAppAdInsertionFactory(addonsConfig.adInsertion, device),
                            loadSyntheticEventAddons()
                        ].concat(_to_consumable_array(loaders)))
                    ];
                case 2:
                    _ref1 = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), streamMetadataParser = _ref1[0], adInsertion = _ref1[1], syntheticEvents = _ref1[2];
                    addonFactories = {
                        adInsertion: adInsertion,
                        // TODO: Update this once we have One-App Advertising requirements
                        reporting: reportingAddonFactories,
                        vac: vamAddonLoader.create,
                        streamMetadataParser: streamMetadataParser,
                        syntheticEvents: syntheticEvents,
                        pine: pineAddonLoader.create
                    };
                    return [
                        2,
                        {
                            addonLoaders: [],
                            addonFactories: addonFactories
                        }
                    ];
            }
        });
    });
    return _oneAppAddonFactories.apply(this, arguments);
}
export function load(internalConfigPerPlaybackType, device) {
    return _load.apply(this, arguments);
}
function _load() {
    _load = _async_to_generator(function(internalConfigPerPlaybackType, device) {
        var _ref, addonLoaders, addonFactories, _obj;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        oneAppAddonFactories(internalConfigPerPlaybackType, device)
                    ];
                case 1:
                    _ref = _state.sent(), addonLoaders = _ref.addonLoaders, addonFactories = _ref.addonFactories;
                    return [
                        2,
                        {
                            addonFactories: addonFactories,
                            addonLoaders: addonLoaders,
                            propositionOvpConfig: {
                                cdnParameters: {
                                    audio: true,
                                    subtitle: true,
                                    forcedNarrative: true,
                                    trickplay: false
                                },
                                endpoints: _define_property({}, PlaybackType.SingleLiveEvent, {
                                    shouldApplyLinearEndpointModifications: true
                                }),
                                fxbwReplacement: _define_property({}, PlayerType.WebMaf, true),
                                drm: {
                                    excludeCertificateUrl: true
                                }
                            },
                            propositionPlayerConfig: (_obj = {}, _define_property(_obj, PlayerType.Shaka, oneAppShakaConfig), _define_property(_obj, PlayerType.Chromecast, {
                                overrideCafDuration: true
                            }), _obj),
                            propositionDrmConfig: oneAppDrmConfig,
                            vpiProvider: loadVpiProvider(internalConfigPerPlaybackType.staticConfig.vpi, internalConfigPerPlaybackType.default.addons),
                            adPolicy: OneAppAdPolicy,
                            devicePlaybackCapabilities: {
                                slePrerollSupported: getSlePrerollSupport(device.deviceInfo, device.type),
                                getNumberOfAudioChannels: function(playoutData, supportsCodecSwitching) {
                                    return 2;
                                }
                            },
                            highFramerateValue: 60
                        }
                    ];
            }
        });
    });
    return _load.apply(this, arguments);
}

//# sourceMappingURL=loader.js.map